import Dashboard from "../components/dashboard";
import DashboardPurchase from "../components/dashboardPurchase";
import DashboardFinance from "../components/dashboardFinance";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { LayoutDashboard } from "lucide-react";

const DashboardPage = () => {

    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    // Normalise values such as "Pre Sales", "pre-sales", "Bid Manager"
    // and "bid-manager" before matching the department.
    const currentUserRole = (user?.department || "guest")
        .toLowerCase()
        .replace(/[\s_-]+/g, "");
    const renderDashboard = () => {
        switch (currentUserRole) {

            case "sales":
                return <Dashboard dashboardType="sales" />;

            case "presales":
                return <Dashboard dashboardType="presales" />;

            case "bidmanager":
                return <Dashboard dashboardType="bidmanager" />;

            case "purchase":
                return <DashboardPurchase />;

            case "finance":
                return <DashboardFinance />;
            
            case "admin":
                return <Dashboard dashboardType="sales" />;

            default:
                return (
                    <div className="flex items-center justify-center h-[80vh]">
                        <h2 className="text-xl font-semibold text-red-600">
                            No Dashboard Assigned
                        </h2>
                    </div>
                );
        }
    };

    return (
        <>
            <Header
                title="Dashboard"
                icon={<LayoutDashboard className="w-5 h-5" />}
            />

            <Sidebar />

            {renderDashboard()}
        </>
    );
};

export default DashboardPage;
